// extracted by mini-css-extract-plugin
export default {"card":"Login_card__dGX5z","submitBtnContainer":"Login_submitBtnContainer__zxX2X","loginTableContainer":"Login_loginTableContainer__qPSbE"};